import { DimensionEcranForm } from "@/components/common/ScreenDimensionForm";
import ProfileCard from "@/components/practitioner/ProfileCard";

export default function ProfilePractitioner() {
  return (
    <div className="w-full flex flex-col justify-center h-full items-center">
      <ProfileCard />
      <DimensionEcranForm portal='practitioner'/>
    </div>
  );
}
